// @flow

import React from 'react';
import { get as _get, set as _set, isNil as _isNil } from 'lodash';
import * as RenterApp from 'styles/Home/StyledRenterApplication';
import BackButton from 'components/renter_application/BackButtonComponent';
import InputComponent from 'components/shared/InputComponent';
import ScreeningParamsActions from 'actions/ScreeningParamsActions';
import LocationActions from 'actions/LocationActions';
import ScreeningParamsStore from 'stores/ScreeningParamsStore';
import LocationStore from 'stores/LocationStore';
import * as Validations from 'validations/HomieValidations';
import NumberInputForm from 'components/shared/NumberInputFormComponent';
import styled from 'styled-components';
import * as Buttons from 'styles/Buttons';
import StatusOptionPetsForm from 'components/shared/StatusOptionPetsFormComponent';
import Dog from 'AssetsRoot/images/homie_v3/dog.svg.react';
import DogWhite from 'AssetsRoot/images/homie_v3/dog_white.svg.react';
import InputCodePhone from 'components/shared/InputPhoneCode';
import NeigborhoodActions from 'actions/NeighborhoodActions';
import NeighborhoodStore from 'stores/NeighborhoodStore';
import Spinner from 'components/shared/Spinner';
import HomieContext from 'HomieContext';
import VerificationWhatsapp from 'components/shared/VerificationWhatsappComponent';
import NotifyConfirmation from 'actions/NotifyConfirmationActions';
import swal from '@sweetalert/with-react';
import $_ from 'jquery';
import MessageFlashComponent from 'components/shared/MessageFlashComponent';
import { hasRoles } from '../../../modules/dashboards/utils/ValidateRole';

const Living_situation = 'living_situations';
const Civil_statuses = 'civil_statuses';
const Degree_levels = 'degree_levels';

const ExtraPersonContainer = styled.div`
  display: block;
  &:first-child {
    padding-top: 20px;
  }
`;

const RemovePersonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const RemovePersonSeparator = styled.hr`
  flex: 1 1 100%;
  margin-top: 7px;
  margin-bottom: 20px;
`;

const RemovePersonAction = styled.span`
  margin-left: 10px;
  color: ${color => color || '#278C7E'};
  cursor: pointer;
`;

const AddPersonButton = styled(Buttons.DefaultButton)`
  width: 100%;
  margin-bottom: 30px;
  color: #4a4a4a;
  box-shadow: none;
  border: 1px solid #cdcdcd;

  &:hover {
    background-color: #f2f1f1;
  }
`;

const StyledForm = styled.form`
  margin-top: 25px;
  padding-top: ${props => (props.addPadding ? 70 : 0)}px;
`;

const BackButtonContainer = styled(RenterApp.BackButtonContainer)`
  top: 15px;
  left: 15px;
`;

const WrapperWhatsappVerification = styled.div`
  padding: 15px 0;
  margin-bottom: 10px;
  background: #f0ecfc;
`;

const CancelAppButton = styled(RenterApp.CancelAppButton)`
  top: 20px;
  right: 15px;
  height: 24px;
`;

type PropsType = {
  homeApplication: any,
  onChange: (any, any) => void,
  onCancel?: () => void,
  onPrevStep: () => void,
  isForAdvisor?: boolean,
  spinnerVisible?: boolean,
  scrollAction?: () => void,
  sendWhatsappVerification: any,
  color?: string
};

type StateType = {
  user: {
    uid: string,
    name: string,
    last_name: string,
    second_last_name: string,
    gender: string,
    rfc: string,
    email: string,
    date_of_birth: string,
    country_of_birth: string,
    state_of_birth: string,
    marital_status: string,
    number_of_kids: string,
    degree: string,
    college: string,
    phone_country_code: string,
    mobile_phone: string
  },
  address: {
    street: string,
    ext_number: string,
    int_number: string,
    neighborhood: string,
    town: string,
    zip: string,
    country: string,
    is_foreigner: boolean
  },
  pickingCountryCode: boolean,
  has_rented_previously: boolean,
  homies: Array<any>,
  has_pets: boolean,
  number_of_pets: number,
  countries: Array<any>,
  civilStatuses: Array<any>,
  degreeLevels: Array<any>,
  neighborhood: Array<any>,
  generalError: boolean,
  subMessageZip: string,
  disabledButtonCode: boolean,
  timmerRun: boolean,
  whatsappVerificationSuccess: boolean
};

export default class ProfileContent extends React.Component<
  PropsType,
  StateType
> {
  static defaultProps = {
    isForAdvisor: false
  };

  state = {
    user: this.defaultValues.user,
    address: this.defaultValues.address,
    has_rented_previously: this.defaultValues.has_rented_previously
      ? this.defaultValues.has_rented_previously
      : null,
    homies: this.defaultValues.homies,
    has_pets: this.defaultValues.has_pets,
    number_of_pets: this.defaultValues.number_of_pets,
    countries: [],
    civilStatuses: [],
    degreeLevels: [],
    neighborhood: [],
    generalError: false,
    pickingCountryCode: false,
    subMessageZip: '',
    timmerRun: true,
    disabledButtonCode: false,
    whatsappVerificationSuccess: false
  };

  get defaultValues(): any {
    const home_application = this.props.homeApplication;
    const user = home_application.user;
    const address = home_application.address;

    const phoneCountryCode = _get(user, 'phone_country_code') || 52;
    const mobilePhone = _get(user, 'mobile_phone');
    return {
      user: {
        uid: _get(user, 'id'),
        name: _get(user, 'name'),
        last_name: _get(user, 'last_name'),
        second_last_name: _get(user, 'second_last_name'),
        gender: 'na',
        rfc: _get(user, 'rfc'),
        email: _get(user, 'email'),
        date_of_birth: _get(user, 'date_of_birth'),
        country_of_birth: _get(user, 'country_of_birth'),
        state_of_birth: _get(user, 'state_of_birth'),
        marital_status: '',
        degree: '',
        college: '',
        phone_country_code: phoneCountryCode,
        mobile_phone: _isNil(user.phone_country_code)
          ? mobilePhone.replace('+', '')
          : mobilePhone.replace(phoneCountryCode, ''),

        number_of_kids: _get(user, 'number_of_kids')
      },
      address: {
        street: _get(address, 'street') || '',
        ext_number: _get(address, 'ext_number') || '',
        int_number: _get(address, 'int_number') || '',
        neighborhood: _get(address, 'neighborhood') || '',
        state: _get(address, 'state') || '',
        town: _get(address, 'town') || '',
        zip: _get(address, 'zip') || '',
        country: _get(address, 'country') || '',
        is_foreigner: _get(address, 'is_foreigner') || false
      },
      has_rented_previously: _get(home_application, 'has_rented_previously'),
      homies: _get(home_application, 'homies') || [
        { name: '', last_name: '', second_last_name: '', date_of_birth: '' }
      ],
      has_pets: _get(home_application, 'has_pets') || false,
      number_of_pets: _get(home_application, 'number_of_pets') || 0
    };
  }

  componentDidMount() {
    ScreeningParamsActions.getScreeningParams({ name: Living_situation });
    ScreeningParamsActions.getScreeningParams({ name: Civil_statuses });
    ScreeningParamsActions.getScreeningParams({ name: Degree_levels });
    LocationActions.getCountries();
    const defaultCountry = this.props.homeApplication.user.country_of_birth;
    if (defaultCountry !== null) {
      LocationActions.getStatesByCountry(defaultCountry);
    }
  }

  componentWillMount() {
    const ha = this.props.homeApplication;
    const haAddress = ha.address;
    if (haAddress && haAddress.zip !== '')
      NeigborhoodActions.getNeighborhoods({ zip_code: haAddress.zip });

    NeighborhoodStore.addChangeListener(this.onNeighborhoods);
    ScreeningParamsStore.addChangeListener(this.onScreeningCivilStatusesChange);
    ScreeningParamsStore.addChangeListener(this.onScreeningDeegreLevelsChange);
    LocationStore.addCountriesChangeListener(this.setCountries);
  }

  componentWillUnmount() {
    NeighborhoodStore.removeChangeListener(this.onNeighborhoods);
    ScreeningParamsStore.removeChangeListener(
      this.onScreeningCivilStatusesChange
    );
    ScreeningParamsStore.removeChangeListener(
      this.onScreeningDeegreLevelsChange
    );
    LocationStore.removeCountriesChangeListener(this.setCountries);
  }

  onNeighborhoods = (): void => {
    const neighborhoodRequest = NeighborhoodStore.getNeighborhoods();
    let neighborhoods = [];
    let subMessageZip = '';
    if (!neighborhoodRequest.length) {
      subMessageZip = 'Verifique el código postal';
    }
    neighborhoodRequest.map(neighborhood =>
      neighborhoods.push({
        value: neighborhood.name,
        label: neighborhood.name,
        id: neighborhood.id
      })
    );
    this.setState({ subMessageZip, neighborhood: neighborhoods });
  };

  setCountries = (): void => {
    let rawCountries = LocationStore.getCountries();

    this.setState(() => {
      const countries = rawCountries.map(country => {
        return {
          value: country.alpha2,
          label: country.name
        };
      });
      return { countries };
    });
  };

  onScreeningCivilStatusesChange = (): void => {
    let civilStatuses = [];
    const statuses = ScreeningParamsStore.getScreeningParam(Civil_statuses);
    if (typeof statuses !== 'undefined') {
      civilStatuses = statuses.map(item => {
        return {
          value: item.slug,
          label: item.name
        };
      });
    }
    this.setState({ civilStatuses });
  };

  onScreeningDeegreLevelsChange = (): void => {
    let degreeLevels = [];
    const levels = ScreeningParamsStore.getScreeningParam(Degree_levels);
    if (typeof levels !== 'undefined') {
      degreeLevels = levels.map(item => {
        return {
          value: item.slug,
          label: item.name
        };
      });
    }
    this.setState({ degreeLevels });
  };

  addExtraPerson = () => {
    let { homies } = this.state;
    homies.push({
      name: '',
      last_name: '',
      second_last_name: '',
      date_of_birth: ''
    });
    this.setState({ homies });
  };

  removeHomie = (index: number) => {
    let { homies } = this.state;
    homies.splice(index, 1);
    this.setState({ homies });
  };

  onChangeUser = (value: string, name: string) => {
    let user = this.state.user;
    user[name] = value;
    this.setState({ user });
  };

  onChangeUserKid = (value: string) => {
    let user = this.state.user;
    user.number_of_kids = value;
    this.setState({ user });
  };

  onChangeKeyValue = (value: string, key: string) => {
    this.setState(prevState => {
      prevState[key] = value;
      return prevState;
    });
  };

  onChangeAddress = (value: string, name: string) => {
    let address = this.state.address;
    address[name] = value;
    this.setState({ address });
  };

  searchNeigborhood = (codeZip: string): void => {
    this.setState(
      prevState => {
        prevState.address.state = '';
        prevState.address.town = '';
        prevState.address.neighborhood = '';
        return prevState;
      },
      () => NeigborhoodActions.getNeighborhoods({ zip_code: codeZip })
    );
  };

  onChangeNeighborhood = (ev: string, v: string): void => {
    if (this.state.address.neighborhood !== ev) {
      const neighborhoodIndex = this.state.neighborhood.filter(
        neighborhood => neighborhood.value === ev
      );
      const neighborhoodActive = NeighborhoodStore.getNeighborhoodById(
        neighborhoodIndex[0].id
      );
      this.setState(prevState => {
        prevState.address.state = neighborhoodActive.state.name;
        prevState.address.town = neighborhoodActive.city.name;
        prevState.address.neighborhood = ev;
        return prevState;
      });
    }
  };

  onCountryChange = (value: string, path: string) => {
    const prevState = this.state.user.country_of_birth;
    this.onChangeUser(value, path);
    if (prevState !== value && value !== '') {
      LocationActions.getStatesByCountry(value);
    }
  };

  handleInputExtraPersonChangeDateMasked = (index: number, value: string) => {
    let { homies } = this.state;
    homies[index].date_of_birth = value;
    this.setState({ homies });
  };

  handleInputExtraPersonChange = (id: number, field: string, value: string) => {
    let { homies } = this.state;
    homies[id][field] = value;
    this.setState({ homies });
  };

  executeValidations = (): void => {
    document.querySelectorAll('form input, .validated').forEach(el => {
      el.focus();
      el.blur();
    });
  };

  isFieldsValidated = async (): Promise<boolean> => {
    let rErrors = await this.resolveAfter();
    return rErrors === 0;
  };

  resolveAfter = async (): Promise<any> => {
    return new Promise(resolve => {
      setTimeout(() => {
        const lengthError = document.querySelectorAll('form .error-message')
          .length;
        resolve(lengthError);
      }, 250);
    });
  };

  changeFormatDate = (date: string): string => {
    if (_isNil(date)) {
      return '';
    }
    return date.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1');
  };

  handleSubmit = async (event: any) => {
    event.preventDefault();
    this.executeValidations();
    let generalError = false;
    let valid = await this.isFieldsValidated();
    if (valid) {
      this.props.onChange(this.serializeState());
    } else {
      generalError = true;
      if (this.props.isForAdvisor && this.props.scrollAction) {
        this.props.scrollAction();
      } else {
        $_('html, body, #Wrapper').animate({ scrollTop: 0 }, 500);
      }
    }
    this.setState({ generalError });
  };

  serializeState = (): {} => {
    let number_of_pets = _get(this.state, 'number_of_pets');
    if (!this.state.has_pets) {
      number_of_pets = 0;
    }
    let userTemp = _get(this.state, 'user');
    userTemp.mobile_phone = `${this.state.user.phone_country_code}${this.state.user.mobile_phone}`;
    return {
      user: userTemp,
      address: _get(this.state, 'address'),
      has_rented_previously: _get(this.state, 'has_rented_previously'),
      homies: _get(this.state, 'homies'),
      has_pets: _get(this.state, 'has_pets'),
      number_of_pets: number_of_pets,
      step: 'profile'
    };
  };

  handlePickingCountryCode = (isPicking: boolean, code?: number) => {
    this.setState(prevState => {
      _set(prevState, 'pickingCountryCode', isPicking);
      if (!isPicking) {
        _set(prevState, 'user.phone_country_code', code);
      }
      return prevState;
    });
  };

  renderButton = () => {
    const { isForAdvisor, spinnerVisible } = this.props;
    if (isForAdvisor) {
      return (
        !spinnerVisible && (
          <RenterApp.SubmitButton disabled={false} type="submit">
            Siguiente
          </RenterApp.SubmitButton>
        )
      );
    }
    return (
      <RenterApp.SubmitButton disabled={false} type="submit">
        Siguiente
      </RenterApp.SubmitButton>
    );
  };

  renderSpinner = () => {
    const { isForAdvisor, spinnerVisible, color } = this.props;
    return isForAdvisor && spinnerVisible && <Spinner color={color} />;
  };

  changeCkeckOptionForeign = (key: string, value: boolean) => {
    this.setState({
      address: {
        is_foreigner: value
      }
    });
  };

  renderBackButton = () => {
    const { isForAdvisor } = this.props;
    if (!isForAdvisor) {
      return (
        <BackButtonContainer
          onClick={this.props.onPrevStep}
          addMargin={isForAdvisor}
        >
          <BackButton text={'Aplicación'} />
        </BackButtonContainer>
      );
    }
  };

  isForeigner = () => {
    const { address } = this.state;
    if (_get(address, 'is_foreigner')) return true;
    return false;
  };

  renderForeignerRFCMessage = () => {
    if (this.isForeigner())
      return (
        <RenterApp.StyledInputInstructions>
          Si eres extranjero este campo no es necesario
        </RenterApp.StyledInputInstructions>
      );
    return null;
  };

  handleChangeTimmer = (): void => {
    this.setState({
      timmerRun: false,
      disabledButtonCode: false
    });
  };

  renderWhatsappVerification = () => {
    const { currentUser } = this.context;
    if (this.context.currentUser.whatsapp_verified) {
      return null;
    }
    const { mobile_phone, phone_country_code } = this.state.user;
    const updateMobileNumber = (countryCode: string, mobilePhone: string) => {
      this.setState(
        prevState => ({
          user: {
            ...prevState.user,
            phone_country_code: countryCode,
            mobile_phone: mobilePhone
          }
        }),
        () => this.sendWhatsappCode()
      );
    };

    return (
      <WrapperWhatsappVerification>
        <VerificationWhatsapp
          sendWhatsappVerification={this.sendWhatsappVerification}
          placeholder={'Código de confirmación'}
          showButton={true}
          textButton="Aplicar"
          timmerRun={this.state.timmerRun}
          disabledButtonCode={this.state.disabledButtonCode}
          handleChangeTimmer={this.handleChangeTimmer}
          sendWhatsappCode={this.sendWhatsappCode}
          allowChangeMobilePhone={this.props.isForAdvisor}
          phoneValue={mobile_phone}
          phoneCountryCode={phone_country_code}
          currentUserId={currentUser.id}
          updateMobileNumber={updateMobileNumber}
        />
      </WrapperWhatsappVerification>
    );
  };

  sendWhatsappCode = (): void => {
    const { currentUser } = this.context;
    if (!currentUser.whatsapp_verified) {
      const { mobile_phone, phone_country_code } = this.state.user;
      const phoneWithCode = `${phone_country_code}${mobile_phone}`;
      NotifyConfirmation.sendCodeWhatsapp(
        currentUser.id,
        phoneWithCode,
        'home_application',
        () => {
          this.setState({
            timmerRun: true,
            disabledButtonCode: true
          });
        },
        error => {
          swal('¡Algo salió mal!', error, 'error');
        }
      ).then(() => {
        this.context.currentUser.lastCodeDate = new Date();
      });
    }
  };

  sendWhatsappVerification = (code: string): void => {
    NotifyConfirmation.verifyCodeWhatsapp(
      this.context.currentUser.id,
      code,
      () => {
        this.setState({
          whatsappVerificationSuccess: true
        });
      },
      error => {
        swal('¡Algo salió mal!', error.responseJSON.message, 'error');
      }
    );
  };

  isVerifiedWhatsapp = () => {
    let { whatsapp_verified } = this.context.currentUser;
    return !whatsapp_verified;
  };

  isAdminOrAdvisor = () => {
    const { currentUser } = this.context;
    return hasRoles(currentUser, ['admin', 'super_admin', 'agent']);
  };

  closeVerificationSuccessMessage = () => {
    this.setState({ whatsappVerificationSuccess: false });
  };

  render() {
    const { user, has_pets, number_of_pets, pickingCountryCode } = this.state;
    const { isForAdvisor, color } = this.props;

    return (
      <>
        {this.state.whatsappVerificationSuccess && (
          <MessageFlashComponent
            isHomie={!isForAdvisor}
            message="¡Listo! Hemos verificado tu número de whatsapp"
            visible
            closeMessageAction={this.closeVerificationSuccessMessage}
          />
        )}
        <RenterApp.AppTabContainer>
          {this.renderBackButton()}
          <RenterApp.AppTabForm>
            <StyledForm onSubmit={this.handleSubmit}>
              <RenterApp.Title>Verifica tus datos</RenterApp.Title>
              <InputComponent
                name="name"
                value={user.name || ''}
                type="text"
                placeholder="Nombre(s)"
                onValueChange={this.onChangeUser}
                schema={Validations.RequiredNameSchema}
              />
              <InputComponent
                name="last_name"
                value={user.last_name || ''}
                type="text"
                placeholder="Apellido paterno"
                onValueChange={this.onChangeUser}
                schema={Validations.RequiredNameSchema}
              />
              <InputComponent
                name="second_last_name"
                value={user.second_last_name || ''}
                type="text"
                placeholder="Apellido materno"
                onValueChange={this.onChangeUser}
                schema={Validations.RequiredNameSchema}
              />
              <InputComponent
                name="date_of_birth"
                value={user.date_of_birth || ''}
                type="date"
                placeholder="Fecha de nacimiento"
                onValueChange={this.onChangeUser}
                //schema={Validations.va}
              />
              <InputComponent
                name="rfc"
                value={user.rfc || ''}
                type="text"
                placeholder="RFC"
                onValueChange={this.onChangeUser}
                schema={
                  this.isForeigner()
                    ? Validations.RFCSchema
                    : Validations.RequiredRFCSchema
                }
              />
              {this.renderForeignerRFCMessage()}
              <RenterApp.EndSectionSpace />
              <InputComponent
                name="email"
                value={user.email || ''}
                type="email"
                placeholder="E-mail"
                onValueChange={this.onChangeUser}
                disabled={true}
                schema={Validations.RequiredEmailSchema}
              />
              <InputCodePhone
                type="text"
                placeholder={'Teléfono'}
                name="mobile_phone"
                value={user.mobile_phone}
                pickingCountryCode={pickingCountryCode}
                countryCode={+user.phone_country_code}
                handleCountryCodeClick={() => {
                  this.handlePickingCountryCode(true);
                }}
                handleCountryCodePicked={(el: any) => {
                  this.handlePickingCountryCode(false, +el.value);
                }}
                onValueChange={this.onChangeUser}
                schema={Validations.PhoneNumberSchemaApplication}
              ></InputCodePhone>
              <RenterApp.EndSectionSpace />

              <RenterApp.EndSectionSpace />
              <RenterApp.Title>¿Tienes hijos?</RenterApp.Title>
              <NumberInputForm
                name="number_of_kids"
                minNumber={0}
                maxNumber={20}
                value={user.number_of_kids}
                onValueChange={this.onChangeUserKid}
                color={color}
              />
              <RenterApp.EndSectionSpace />
              <RenterApp.Title>¿Quién va a vivir contigo?</RenterApp.Title>
              {this.state.homies.map((extraPerson, index) => (
                <ExtraPersonContainer key={index}>
                  <RemovePersonContainer>
                    <RemovePersonSeparator />
                    <RemovePersonAction
                      onClick={() => {
                        this.removeHomie(index);
                      }}
                      color={color}
                    >
                      Eliminar
                    </RemovePersonAction>
                  </RemovePersonContainer>
                  <RenterApp.StyledOptionalInput>
                    <InputComponent
                      type="text"
                      id={index}
                      onValueChange={value => {
                        this.handleInputExtraPersonChange(index, 'name', value);
                      }}
                      name={`extra_person_${index}_name`}
                      placeholder="Nombre"
                      value={this.state.homies[index].name}
                      schema={Validations.RequiredNameSchema}
                    />
                  </RenterApp.StyledOptionalInput>
                  <RenterApp.StyledOptionalInput>
                    <InputComponent
                      type="text"
                      id={index}
                      onValueChange={value => {
                        this.handleInputExtraPersonChange(
                          index,
                          'last_name',
                          value
                        );
                      }}
                      name={`extra_person_${index}_last_name`}
                      placeholder="Apellido(s)"
                      value={this.state.homies[index].last_name}
                      schema={Validations.RequiredNameSchema}
                    />
                  </RenterApp.StyledOptionalInput>
                </ExtraPersonContainer>
              ))}

              <AddPersonButton
                type="button"
                onClick={() => this.addExtraPerson()}
              >
                Agregar{this.state.homies.length > 0 ? ' otra ' : ' '}persona
              </AddPersonButton>
              <StatusOptionPetsForm
                name={'has_pets'}
                text={'Voy a vivir con mascotas'}
                Icon={Dog}
                IconSelected={DogWhite}
                value={has_pets}
                id={'has_pets'}
                onChangeValue={this.onChangeKeyValue}
                color={color}
              />

              {has_pets === true && (
                <div>
                  <RenterApp.Title>¿Cuántas?</RenterApp.Title>
                  <NumberInputForm
                    name="number_of_pets"
                    minNumber={1}
                    maxNumber={20}
                    value={number_of_pets}
                    onValueChange={this.onChangeKeyValue}
                    color={color}
                  />
                </div>
              )}

              <RenterApp.EndSectionSpace />
              {this.renderButton()}
              {this.renderSpinner()}
            </StyledForm>
          </RenterApp.AppTabForm>
          {!isForAdvisor && (
            <CancelAppButton onClick={this.props.onCancel} color={color}>
              Cancelar aplicación
            </CancelAppButton>
          )}
        </RenterApp.AppTabContainer>
      </>
    );
  }
}

ProfileContent.contextType = HomieContext;
